import React from 'react'

import cx from 'classnames'

import { IconButton, IconButtonProps } from '@driftt/tide-core'

import styles from './styles.module.css'

export const ConvoIconButton: React.FC<IconButtonProps> = (props) => (
  <IconButton {...props} className={cx(styles.iconBtn, props.className)} />
)
